import { REDIRECT_URLS } from 'config'
import { redirect } from 'react-router-dom'
import { useLoaderData } from 'react-router-dom'

const loader = ({ request }) => {
  const { searchParams: params } = new URL(request.url)
  const generalStatus = params?.get('g') as 'none' | 'created' | 'failed'
  const invoiceStatus = params?.get('i') as 'none' | 'created' | 'failed'
  const orderFormStatus = params?.get('o') as 'none' | 'created' | 'failed'
  const useInvoiceOCR = params?.get('ui') === '1'
  const useOrderForm = params?.get('uo') === '1'
  const useConcur = params?.get('uc') === '1'
  if (
    !generalStatus ||
    !invoiceStatus ||
    !orderFormStatus ||
    !params?.get('ui') ||
    !params?.get('uc') ||
    !params?.get('uo')
  ) {
    throw Error('params error')
  }
  if (generalStatus === 'created' && invoiceStatus === 'created' && orderFormStatus === 'created') {
    // ?
    return redirect(REDIRECT_URLS.HOME)
  }

  return {
    generalStatus,
    invoiceStatus,
    orderFormStatus,
    useInvoiceOCR,
    useOrderForm,
    useConcur,
  }
}

export default loader

export function useInitApiGatewayDialogLoaderData() {
  return useLoaderData() as Exclude<ReturnType<typeof loader>, Response>
}
